import { useState, useEffect } from "react";
import axios from "axios";
import { ArrowLeft, Barbell, Spinner, Info } from "@phosphor-icons/react";
import { useWeightUnit } from "@/lib/units";
import ExerciseDemoButton from "@/components/ExerciseDemoButton";

// Per-exercise unique images from Unsplash
const EXERCISE_IMAGES = {
  // Chest
  "bench press": "https://images.unsplash.com/photo-1584466977773-e625c37cdd50?w=400&h=280&fit=crop",
  "flat bench press": "https://images.unsplash.com/photo-1584466977773-e625c37cdd50?w=400&h=280&fit=crop",
  "barbell bench press": "https://images.unsplash.com/photo-1532029837206-abbe2b7620e3?w=400&h=280&fit=crop",
  "incline barbell press": "https://images.unsplash.com/photo-1585152968992-d2b9444408cc?w=400&h=280&fit=crop",
  "incline dumbbell press": "https://images.unsplash.com/photo-1646072508263-af94f0218bf0?w=400&h=280&fit=crop",
  "flat dumbbell press": "https://images.unsplash.com/photo-1704223523449-ca3925f89dcc?w=400&h=280&fit=crop",
  "incline dumbbell flyes": "https://images.unsplash.com/photo-1692372372344-41aed374b848?w=400&h=280&fit=crop",
  "dumbbell flyes": "https://images.unsplash.com/photo-1692372372344-41aed374b848?w=400&h=280&fit=crop",
  "cable flyes": "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&h=280&fit=crop",
  "cable crossovers": "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&h=280&fit=crop",
  "pec deck": "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&h=280&fit=crop",
  "close-grip bench press": "https://images.unsplash.com/photo-1585152968992-d2b9444408cc?w=400&h=280&fit=crop",
  "dumbbell floor press": "https://images.unsplash.com/photo-1704223523449-ca3925f89dcc?w=400&h=280&fit=crop",
  "push-ups": "https://images.unsplash.com/photo-1714646442330-9068099f5521?w=400&h=280&fit=crop",
  "push-up variations (4 types)": "https://images.unsplash.com/photo-1714646442330-9068099f5521?w=400&h=280&fit=crop",
  "diamond push-ups": "https://images.unsplash.com/photo-1549943365-6bb16fecadeb?w=400&h=280&fit=crop",
  "archer push-ups": "https://images.unsplash.com/photo-1549943365-6bb16fecadeb?w=400&h=280&fit=crop",
  "pike push-ups": "https://images.unsplash.com/photo-1626444231642-6bd985bca16a?w=400&h=280&fit=crop",
  "dips": "https://images.unsplash.com/photo-1598575435247-2572be03bf6d?w=400&h=280&fit=crop",
  "dips (chair)": "https://images.unsplash.com/photo-1598575435247-2572be03bf6d?w=400&h=280&fit=crop",
  "dips (between surfaces)": "https://images.unsplash.com/photo-1598575435247-2572be03bf6d?w=400&h=280&fit=crop",
  // Shoulders
  "overhead press": "https://images.unsplash.com/photo-1758875568628-12fc3376f433?w=400&h=280&fit=crop",
  "seated dumbbell press": "https://images.unsplash.com/photo-1585152968992-851c3a8e1678?w=400&h=280&fit=crop",
  "dumbbell shoulder press": "https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5?w=400&h=280&fit=crop",
  "lateral raises": "https://images.unsplash.com/photo-1600026453249-24a43274d65a?w=400&h=280&fit=crop",
  "cable lateral raises": "https://images.unsplash.com/photo-1641337221253-fdc7237f6b61?w=400&h=280&fit=crop",
  "dumbbell lateral raises": "https://images.unsplash.com/photo-1600026453249-24a43274d65a?w=400&h=280&fit=crop",
  "rear delt flyes": "https://images.unsplash.com/photo-1598575435247-2572be03bf6d?w=400&h=280&fit=crop",
  "reverse flyes": "https://images.unsplash.com/photo-1598575435247-2572be03bf6d?w=400&h=280&fit=crop",
  "face pulls": "https://images.unsplash.com/photo-1532384816664-01b8b7238c8d?w=400&h=280&fit=crop",
  "dumbbell shrugs": "https://images.unsplash.com/photo-1598575422854-175a39a37c93?w=400&h=280&fit=crop",
  // Back
  "deadlift": "https://images.unsplash.com/photo-1606657830879-00d70555b1b6?w=400&h=280&fit=crop",
  "barbell rows": "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=400&h=280&fit=crop",
  "dumbbell rows": "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=400&h=280&fit=crop",
  "t-bar rows": "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=400&h=280&fit=crop",
  "seated cable row": "https://images.unsplash.com/photo-1519505907962-0a6cb0167c73?w=400&h=280&fit=crop",
  "cable rows": "https://images.unsplash.com/photo-1519505907962-0a6cb0167c73?w=400&h=280&fit=crop",
  "lat pulldown": "https://images.unsplash.com/photo-1534872850130-5355701fcc89?w=400&h=280&fit=crop",
  "lat pulldown (wide)": "https://images.unsplash.com/photo-1582852629342-f12dbf7c66cf?w=400&h=280&fit=crop",
  "straight-arm pulldown": "https://images.unsplash.com/photo-1694192714423-c420d00b9928?w=400&h=280&fit=crop",
  "pull-ups": "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?w=400&h=280&fit=crop",
  "wide-grip pull-ups": "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?w=400&h=280&fit=crop",
  "weighted pull-ups": "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?w=400&h=280&fit=crop",
  "chin-ups": "https://images.unsplash.com/photo-1692369608023-a3822e070ee9?w=400&h=280&fit=crop",
  "inverted rows": "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=400&h=280&fit=crop",
  // Legs
  "barbell squat": "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=400&h=280&fit=crop",
  "hack squat": "https://images.unsplash.com/photo-1554284126-aa88f22d8b74?w=400&h=280&fit=crop",
  "goblet squat": "https://images.unsplash.com/photo-1618688862225-ac941a9da58f?w=400&h=280&fit=crop",
  "romanian deadlift": "https://images.unsplash.com/photo-1706029831405-619b27e3260c?w=400&h=280&fit=crop",
  "leg press": "https://images.unsplash.com/photo-1744551612249-655d096b9f95?w=400&h=280&fit=crop",
  "leg curl": "https://images.unsplash.com/photo-1675026482808-33f7515ecddd?w=400&h=280&fit=crop",
  "leg extension": "https://images.unsplash.com/photo-1434682772747-f16d3ea162c3?w=400&h=280&fit=crop",
  "walking lunges": "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&h=280&fit=crop",
  "dumbbell lunges": "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&h=280&fit=crop",
  "bulgarian split squat": "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=400&h=280&fit=crop",
  "hip thrust": "https://images.unsplash.com/photo-1598575435247-2572be03bf6d?w=400&h=280&fit=crop",
  "calf raises": "https://images.unsplash.com/photo-1545612036-2872840642dc?w=400&h=280&fit=crop",
  "standing calf raises": "https://images.unsplash.com/photo-1545612036-2872840642dc?w=400&h=280&fit=crop",
  "dumbbell calf raises": "https://images.unsplash.com/photo-1545612036-2872840642dc?w=400&h=280&fit=crop",
  "pistol squats": "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=400&h=280&fit=crop",
  "hindu squats": "https://images.unsplash.com/photo-1554284126-aa88f22d8b74?w=400&h=280&fit=crop",
  "squats": "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=400&h=280&fit=crop",
  "jump squats": "https://images.unsplash.com/photo-1554284126-aa88f22d8b74?w=400&h=280&fit=crop",
  "squat jumps": "https://images.unsplash.com/photo-1554284126-aa88f22d8b74?w=400&h=280&fit=crop",
  "lunges": "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&h=280&fit=crop",
  "jump lunges": "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&h=280&fit=crop",
  "dumbbell step-ups": "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&h=280&fit=crop",
  "step-up jumps": "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&h=280&fit=crop",
  "dumbbell sumo squat": "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=400&h=280&fit=crop",
  "dumbbell romanian deadlift": "https://images.unsplash.com/photo-1706029831405-619b27e3260c?w=400&h=280&fit=crop",
  "dumbbell glute bridge": "https://images.unsplash.com/photo-1598575435247-2572be03bf6d?w=400&h=280&fit=crop",
  "nordic curls": "https://images.unsplash.com/photo-1675026482808-33f7515ecddd?w=400&h=280&fit=crop",
  // Arms
  "barbell curls": "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=400&h=280&fit=crop",
  "ez bar curls": "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=400&h=280&fit=crop",
  "dumbbell curls": "https://images.unsplash.com/photo-1659614871735-e133639e4b28?w=400&h=280&fit=crop",
  "hammer curls": "https://images.unsplash.com/photo-1641337221253-fdc7237f6b61?w=400&h=280&fit=crop",
  "preacher curls": "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=400&h=280&fit=crop",
  "concentration curls": "https://images.unsplash.com/photo-1659614871735-e133639e4b28?w=400&h=280&fit=crop",
  "dumbbell curl to press": "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=400&h=280&fit=crop",
  "tricep pushdowns": "https://images.unsplash.com/photo-1532384816664-01b8b7238c8d?w=400&h=280&fit=crop",
  "rope pushdowns": "https://images.unsplash.com/photo-1532384816664-01b8b7238c8d?w=400&h=280&fit=crop",
  "overhead tricep extension": "https://images.unsplash.com/photo-1598575422854-175a39a37c93?w=400&h=280&fit=crop",
  "dumbbell overhead extension": "https://images.unsplash.com/photo-1598575422854-175a39a37c93?w=400&h=280&fit=crop",
  "skull crushers": "https://images.unsplash.com/photo-1585152968992-d2b9444408cc?w=400&h=280&fit=crop",
  "tricep kickbacks": "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=400&h=280&fit=crop",
  "band curls": "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=400&h=280&fit=crop",
  "band tricep extensions": "https://images.unsplash.com/photo-1598575422854-175a39a37c93?w=400&h=280&fit=crop",
  // Cardio
  "burpees": "https://images.unsplash.com/photo-1549943365-6bb16fecadeb?w=400&h=280&fit=crop",
  "mountain climbers": "https://images.unsplash.com/photo-1626444231642-6bd985bca16a?w=400&h=280&fit=crop",
  "high knees": "https://images.unsplash.com/photo-1698671823406-035c77ff6fcd?w=400&h=280&fit=crop",
  "jumping jacks": "https://images.unsplash.com/photo-1698671823406-035c77ff6fcd?w=400&h=280&fit=crop",
  "speed skaters": "https://images.unsplash.com/photo-1766970096346-937852c7d350?w=400&h=280&fit=crop",
  "lateral bounds": "https://images.unsplash.com/photo-1766970096346-937852c7d350?w=400&h=280&fit=crop",
  "star jumps": "https://images.unsplash.com/photo-1698671823406-035c77ff6fcd?w=400&h=280&fit=crop",
  "treadmill sprint": "https://images.unsplash.com/photo-1755877956621-5fac2eae4ebb?w=400&h=280&fit=crop",
  "treadmill jog": "https://images.unsplash.com/photo-1758922769578-68c5ba000d87?w=400&h=280&fit=crop",
  "jog": "https://images.unsplash.com/photo-1758922769578-68c5ba000d87?w=400&h=280&fit=crop",
  "sprint": "https://images.unsplash.com/photo-1698671823406-035c77ff6fcd?w=400&h=280&fit=crop",
  "cycling": "https://images.unsplash.com/photo-1519505645104-c7be90e0d630?w=400&h=280&fit=crop",
  "assault bike": "https://images.unsplash.com/photo-1519505645104-c7be90e0d630?w=400&h=280&fit=crop",
  "elliptical": "https://images.unsplash.com/photo-1434682772747-f16d3ea162c3?w=400&h=280&fit=crop",
  "stair climber": "https://images.unsplash.com/photo-1598575435247-2572be03bf6d?w=400&h=280&fit=crop",
  "stair sprints": "https://images.unsplash.com/photo-1598575435247-2572be03bf6d?w=400&h=280&fit=crop",
  "rowing machine": "https://images.unsplash.com/photo-1519505907962-0a6cb0167c73?w=400&h=280&fit=crop",
  "box jumps": "https://images.unsplash.com/photo-1554284126-aa88f22d8b74?w=400&h=280&fit=crop",
  "tuck jumps": "https://images.unsplash.com/photo-1554284126-aa88f22d8b74?w=400&h=280&fit=crop",
  "basic jump rope": "https://images.unsplash.com/photo-1514994667787-b48ca37155f0?w=400&h=280&fit=crop",
  "double unders": "https://images.unsplash.com/photo-1514994667787-b48ca37155f0?w=400&h=280&fit=crop",
  "high knee jumps": "https://images.unsplash.com/photo-1514994667787-b48ca37155f0?w=400&h=280&fit=crop",
  "criss-cross": "https://images.unsplash.com/photo-1514994667787-b48ca37155f0?w=400&h=280&fit=crop",
  "sprint jump rope": "https://images.unsplash.com/photo-1514994667787-b48ca37155f0?w=400&h=280&fit=crop",
  "jump rope": "https://images.unsplash.com/photo-1514994667787-b48ca37155f0?w=400&h=280&fit=crop",
  "battle ropes": "https://images.unsplash.com/photo-1538805060514-97d9cc17730c?w=400&h=280&fit=crop",
  // Core
  "plank hold": "https://images.unsplash.com/photo-1549943365-6bb16fecadeb?w=400&h=280&fit=crop",
  "plank jacks": "https://images.unsplash.com/photo-1626444231642-6bd985bca16a?w=400&h=280&fit=crop",
  "plank to push-up": "https://images.unsplash.com/photo-1714646442330-9068099f5521?w=400&h=280&fit=crop",
  "l-sit hold": "https://images.unsplash.com/photo-1549943365-6bb16fecadeb?w=400&h=280&fit=crop",
  // Kettlebell / Full body
  "kettlebell swings": "https://images.unsplash.com/photo-1644085159448-1659fd88a217?w=400&h=280&fit=crop",
  "kettlebell deadlift": "https://images.unsplash.com/photo-1618688862225-ac941a9da58f?w=400&h=280&fit=crop",
  "kettlebell clean & press": "https://images.unsplash.com/photo-1644085159448-1659fd88a217?w=400&h=280&fit=crop",
  "kettlebell front squat": "https://images.unsplash.com/photo-1618688862225-ac941a9da58f?w=400&h=280&fit=crop",
  "kettlebell rows": "https://images.unsplash.com/photo-1632077804406-188472f1a810?w=400&h=280&fit=crop",
  "kettlebell goblet squat": "https://images.unsplash.com/photo-1618688862225-ac941a9da58f?w=400&h=280&fit=crop",
  "kettlebell snatch": "https://images.unsplash.com/photo-1644085159448-1659fd88a217?w=400&h=280&fit=crop",
  "kettlebell high pull": "https://images.unsplash.com/photo-1644085159448-1659fd88a217?w=400&h=280&fit=crop",
  "turkish get-up": "https://images.unsplash.com/photo-1618688862225-ac941a9da58f?w=400&h=280&fit=crop",
  "wall balls": "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&h=280&fit=crop",
  "dumbbell thrusters": "https://images.unsplash.com/photo-1585152968992-851c3a8e1678?w=400&h=280&fit=crop",
  "burpee pull-ups": "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?w=400&h=280&fit=crop",
  "air squats": "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=400&h=280&fit=crop",
  // Bands
  "band chest press": "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&h=280&fit=crop",
  "band rows": "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=400&h=280&fit=crop",
  "band squats": "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=400&h=280&fit=crop",
  "band lateral raises": "https://images.unsplash.com/photo-1600026453249-24a43274d65a?w=400&h=280&fit=crop",
  // Animal flow / bodyweight cardio
  "bear crawl": "https://images.unsplash.com/photo-1549943365-6bb16fecadeb?w=400&h=280&fit=crop",
  "bear crawl up stairs": "https://images.unsplash.com/photo-1549943365-6bb16fecadeb?w=400&h=280&fit=crop",
  "crab walk": "https://images.unsplash.com/photo-1626444231642-6bd985bca16a?w=400&h=280&fit=crop",
  "frog jumps": "https://images.unsplash.com/photo-1554284126-aa88f22d8b74?w=400&h=280&fit=crop",
  "inchworms": "https://images.unsplash.com/photo-1714646442330-9068099f5521?w=400&h=280&fit=crop",
  "scorpion kicks": "https://images.unsplash.com/photo-1626444231642-6bd985bca16a?w=400&h=280&fit=crop",
  "duck walk": "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=400&h=280&fit=crop",
  "handstand push-up (wall)": "https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5?w=400&h=280&fit=crop",
  "calf raises on step": "https://images.unsplash.com/photo-1545612036-2872840642dc?w=400&h=280&fit=crop",
};

// Fallback for exercises not in the map
const FALLBACK_IMAGES = [
  "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&h=280&fit=crop",
  "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&h=280&fit=crop",
  "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&h=280&fit=crop",
  "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?w=400&h=280&fit=crop",
  "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=400&h=280&fit=crop",
];

function getExerciseImage(name, idx) {
  const lower = name.toLowerCase();
  if (EXERCISE_IMAGES[lower]) return EXERCISE_IMAGES[lower];
  // Partial match
  for (const [key, url] of Object.entries(EXERCISE_IMAGES)) {
    if (lower.includes(key) || key.includes(lower)) return url;
  }
  return FALLBACK_IMAGES[idx % FALLBACK_IMAGES.length];
}

export default function TemplateDetail({ template, api, onBack }) {
  const { fromKg, label: weightLabel } = useWeightUnit();
  const [exerciseInfo, setExerciseInfo] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (template?.exercises?.length) fetchExerciseInfo();
  }, [template]);

  const fetchExerciseInfo = async () => {
    setLoading(true);
    try {
      const names = template.exercises.map(e => e.name).filter(Boolean);
      const res = await axios.post(`${api}/ai/exercise-info`, { exercises: names });
      setExerciseInfo(res.data.exercises || {});
    } catch (e) {
      console.error("Exercise info error:", e);
    } finally {
      setLoading(false);
    }
  };

  if (!template) return null;

  const totalSets = template.exercises?.reduce((sum, ex) => sum + (ex.sets?.length || 0), 0) || 0;
  const equipColor = template.equipment === "Bodyweight" ? "text-[#22C55E]" : template.equipment === "Home" ? "text-[#F59E0B]" : "text-[#71717A]";

  return (
    <div className="space-y-6" data-testid="template-detail-page">
      <div className="flex items-center gap-4">
        <button onClick={onBack} className="text-[#A1A1AA] hover:text-white transition-colors p-2 border border-[#27272A] hover:border-[#3f3f46]" data-testid="template-detail-back-btn">
          <ArrowLeft size={18} />
        </button>
        <div className="flex-1">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight uppercase text-white" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
            {template.name}
          </h2>
          <div className="flex items-center gap-3 mt-1">
            <span className="text-xs text-[#E05A1D] font-bold uppercase">{template.category}</span>
            {template.equipment && <span className={`text-xs font-bold uppercase ${equipColor}`}>{template.equipment}</span>}
            <span className="text-xs text-[#71717A]">{template.exercises?.length || 0} exercises</span>
            <span className="text-xs text-[#71717A]">{totalSets} total sets</span>
          </div>
        </div>
      </div>

      {template.description && <p className="text-sm text-[#A1A1AA]">{template.description}</p>}

      {loading && (
        <div className="flex items-center gap-2 text-sm text-[#71717A]" data-testid="loading-exercise-info">
          <Spinner size={16} className="animate-spin text-[#E05A1D]" /> Loading exercise instructions...
        </div>
      )}

      <div className="space-y-4" data-testid="template-exercises">
        {template.exercises?.map((ex, idx) => {
          const info = exerciseInfo[ex.name?.toLowerCase()] || null;
          const imgUrl = getExerciseImage(ex.name || "", idx);

          return (
            <div key={idx} className="bg-[#161616] border border-[#27272A] overflow-hidden" data-testid={`template-exercise-detail-${idx}`}>
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-64 h-48 lg:h-auto shrink-0 bg-[#0F0F0F] relative overflow-hidden">
                  <img src={imgUrl} alt={ex.name} className="w-full h-full object-cover opacity-70" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F0F] via-transparent to-transparent" />
                  <div className="absolute bottom-3 left-3 right-3">
                    <span className="text-xs font-bold text-[#E05A1D] uppercase tracking-wider">{info?.muscles || ""}</span>
                  </div>
                </div>
                <div className="flex-1 p-5">
                  <div className="flex items-center gap-2 mb-3 flex-wrap">
                    <Barbell size={18} className="text-[#E05A1D]" weight="bold" />
                    <h3 className="text-lg font-bold tracking-tight uppercase text-white" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>{ex.name}</h3>
                    {ex.name && <ExerciseDemoButton api={api} name={ex.name} />}
                  </div>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {ex.sets?.map((set, sIdx) => (
                      <div key={sIdx} className="bg-[#0F0F0F] border border-[#27272A] px-3 py-1.5 text-center">
                        <p className="text-[10px] text-[#71717A] font-bold uppercase">Set {sIdx + 1}</p>
                        <p className="text-sm font-bold text-white">
                          {set.reps} <span className="text-[#71717A] text-xs">reps</span>
                          {set.weight > 0 && <> x {fromKg(set.weight).toFixed(1)}<span className="text-[#71717A] text-xs">{weightLabel}</span></>}
                        </p>
                      </div>
                    ))}
                  </div>
                  {ex.notes && <p className="text-xs text-[#A1A1AA] mb-3 italic">{ex.notes}</p>}
                  {info ? (
                    <div className="border-t border-[#27272A] pt-3 mt-1">
                      <div className="flex items-start gap-2">
                        <Info size={14} className="text-[#E05A1D] mt-0.5 shrink-0" weight="fill" />
                        <div>
                          <p className="text-sm text-[#E5E5E5] leading-relaxed">{info.instructions}</p>
                          {info.tips && <p className="text-xs text-[#F59E0B] mt-2 font-semibold">Tip: {info.tips}</p>}
                        </div>
                      </div>
                    </div>
                  ) : loading ? (
                    <div className="border-t border-[#27272A] pt-3 mt-1">
                      <div className="flex items-center gap-2 text-xs text-[#71717A]">
                        <Spinner size={12} className="animate-spin" /> Loading instructions...
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
